import axios from "axios";

const getCsrfToken = () => {
    const metaTag = document.querySelector('meta[name="csrf-token"]');
    return metaTag ? metaTag.getAttribute('content') : null;
};

export const client = axios.create({
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
    },
    baseURL:
        process.env.NODE_ENV === 'development' ?
            'http://leaderos-test.com:8888/install' : '/install',
});

client.interceptors.request.use(
    (config) => {
        if (config.method !== 'get') {
            const token = getCsrfToken();
            if (token) {
                config.headers['X-CSRF-Token'] = token;
            }
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export const getLanguages = async () => await client.get('/data/languages');
export const getCurrencies = async () => await client.get('/data/currencies');
export const getTimezones = async () => await client.get('/data/timezones');
export const getCompatibility = async () => await client.post('/steps/compatibility');
export const setDatabase = (data) => client.post('/steps/database', {
    mysqlServer: data.host,
    mysqlPort: data.port,
    mysqlDatabase: data.database,
    mysqlUsername: data.username,
    mysqlPassword: data.password,
});
export const setGeneralSettings = (data) => client.post('/steps/general', {
    siteSlogan: data.websiteTitle,
    siteServerName: data.serverName,
    siteServerIP: data.serverIp,
    sitePasswordType: data.passwordEncryption,
    siteMaintenance: data.maintenance,
    siteLanguage: data.language,
    siteCurrency: data.currency,
    siteTimezone: data.timezone,
});
export const createAdmin = (database, admin, loginProvider) => client.post('/steps/admin', {
    loginProvider: loginProvider,
    mysqlServer: database.host,
    mysqlPort: database.port,
    mysqlDatabase: database.database,
    mysqlUsername: database.username,
    mysqlPassword: database.password,
    accountUsername: loginProvider === 'default' ? admin.realname.toLowerCase() : admin.username,
    accountRealname: admin.realname,
    accountEmail: admin.email,
    accountPassword: admin.password,
    accountPasswordRe: admin.confirmPassword,
});
export const run = (apiKey, game, loginProvider, database, general, admin) => client.post('/steps/run', {
    apiKey: apiKey,
    game: game,
    loginProvider: loginProvider,
    
    mysqlServer: database.host,
    mysqlPort: database.port,
    mysqlDatabase: database.database,
    mysqlUsername: database.username,
    mysqlPassword: database.password,
    
    siteSlogan: general.websiteTitle,
    siteServerName: general.serverName,
    siteServerIP: general.serverIp,
    sitePasswordType: general.passwordEncryption,
    siteMaintenance: general.maintenance,
    siteLanguage: general.language,
    siteCurrency: general.currency,
    siteTimezone: general.timezone,
    
    accountUsername: loginProvider === 'default' ? admin.realname.toLowerCase() : admin.username,
    accountRealname: admin.realname,
    accountEmail: admin.email,
    accountPassword: admin.password,
    accountPasswordRe: admin.confirmPassword,
    accountAvatar: admin.avatar
});

export const check = () => client.get('/install?action=check');